/*eslint-disable*/
import React, { useEffect, useState, useContext, useRef } from 'react'
import './cart.css'
import _ from 'lodash'
import Nodata from '../../../Component/NoData/nodata'
import { percentage, getValidProduct, getvaliditems } from '../../../utils/commonFunctions'
import { useHistory, Link } from 'react-router-dom'
import CartContext from '../../../Product/context/cart/cartContext'
import AuthContext from '../../../Product/context/auth/authContext'
import AlertContext from '../../../Product/context/alert/alertContext'
import ProductContext from '../../../Product/context/product/productContext'
import PosContext from '../../../Product/context/plugin/pos/posContext'
import StripeCardContext from '../../../Product/context/stripe/card/cardContext'
import PluginContext from '../../../Product/context/plugin/pluginContext'
import { currencyFormat, handleRedirectInternal, mapData } from '../../../Product/common/components'
import PrimaryButton from '../../../Product/components/atoms/PrimaryButton'
import { messageHandleBuynow } from '../../../Product/common/socketHandler'
import { socket, socketAuction } from '../../../Product/common/socket'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import BuyerContext from '../../../Product/context/buyer/buyerContext'
import { apiCall } from '../../../Product/common/api'
import * as Yup from 'yup'
import UserActivity from '../UserActivity'
import { useTranslation } from 'react-i18next'
import Qtyinput from '../../../Product/common/Qtyinput'
import { Swiper, SwiperSlide, useSwiper, useSwiperSlide } from 'swiper/react/swiper-react'
import { EffectCoverflow, Pagination, Navigation } from 'swiper'
import 'swiper/swiper-bundle.css'
import Timer from '../../../Product/common/TimerBuynow'
import ReadMore from '../../../Component/ReadMore'
import NoRecordsFound from '../../../Product/components/atoms/NoRecordsFound'
import { useLocation } from 'react-router-dom/cjs/react-router-dom'
import CustomInput from '../../../Product/components/atoms/Inputs/CustomInput'
import SecondaryButton from '../../../Product/components/atoms/SecondaryButton'

const RushCart = (props) => {
    const cartContext = useContext(CartContext)
    const authContext = useContext(AuthContext)
    const buyerContext = useContext(BuyerContext)
    const {
        get_all_card_details,
        getAllStripeCards,
        responseStatus: cardResponseStatus,
        clearResponse: cardClearResponse,
    } = useContext(StripeCardContext)
    const { rushPassFee } = useContext(PluginContext)
    const [viewCartItems, setViewCartItems] = useState([])
    const [cart_error, setCartError] = useState(false)
    const [readers, setReaders] = useState([])
    const [remove_id, setRemoveid] = useState(0)
    const [allData, setAllData] = useState([])
    const [cardData, setCardData] = useState('nocard')
    const { t } = useTranslation()
    const alertContext = useContext(AlertContext)
    const [total, setTotal] = useState(0)
    const [totalBuyersPremium, setTotalBuyersPremium] = useState(0)
    const [shippingFee, setShippingFee] = useState(0)
    const [transactionFee, setTransactionFee] = useState(0)
    const [deposit, setDeposit] = useState(0)
    const [salesTax, setSalesTax] = useState(0)
    const [lineItemFee, setLineItemFee] = useState(0)
    const [taxData, setTaxData] = useState(0)
    const [fee, setFee] = useState(0)
    const [shippingpos, setShippingpos] = useState(0)
    const pass = new URLSearchParams(window.location.search.substring(1)).get('p')
    const pos = new URLSearchParams(window.location.search.substring(1)).get('pos')
    const type = new URLSearchParams(window.location.search.substring(1)).get('type')
    const id = new URLSearchParams(window.location.search.substring(1)).getAll('id')
    const [total_error, setTotalerror] = useState('')
    const [intervalFunction, setIntervalFunction] = useState('')
    const [similarCart, setSimilarCart] = useState([])
    const [cartPass, setCartPass] = useState(0)
    const [allUsers, setAllUsers] = useState([])
    const [loader, setCardLoading] = useState(false)
    const [paymentLoading, setPaymentLoading] = useState(false)

    const [paymentId, setPaymentId] = useState({
        payment_intent_id: '',
        invoice_id: [],
    })
    const [posLoading, setPosLoading] = useState(false)
    const [buyerId, setBuyerId] = useState(0)

    let history = useHistory()
    const { user } = authContext
    const checkBidShopTheme = document.body.className == 'liquidationTwo bidShop'
    const {
        addToCart,
        buyer_cartitems,
        getUserCart,
        removeFromCart,
        updateFromCart,
        responseStatus,
    } = cartContext
    const { setAlert, clearAlert } = alertContext
    const {
        processPosBuynow,
        completePosBuynow,
        getActiveUsers,
        all_active_users,
        getCheckoutAuction,
        invoice_details,
        processPosAuction,
        processPosOffline,
        getSimilarProducts,
        similar_products,
        responseStatus: response,
    } = useContext(ProductContext)
    const { allReaders, all_readers, payment_status, paymentStatus } = useContext(PosContext)
    const { get_ship_station_amount, shipping_rate_calculation, clear_ship_station_amount } =
        buyerContext
    const categoryTypes = {}
    global.allCategories.map((catgeory) => (categoryTypes[catgeory.id] = catgeory))
    const onChangeCard = (e) => {
        e.target.checked ? setCardData(e.target.value) : setCardData('nocard')
    }
    const handleRushPassPayment = async () => {
        if (cardData == 'nocard') {
            setAlert('Please Choose a card!', 'error')
            setPaymentLoading(false)
        } else {
            setPaymentLoading(true)
            // {
            //     id: 1,
            //     name: 'Single-Day Pass',
            //     price: 5,
            //     qty: 1,
            //     days: 1,
            // }
            const line_item = viewCartItems.map((item) => {
                return {
                    name: item.name,
                    per_price: item.price,
                    days: item.days,
                    qty: item.qty * item.days,
                    purchase_qty: item.qty,
                    purchase_amount: item.qty * item.price,
                }
            })

            const paymentBody = {
                user_id: user.id,
                line_item: line_item,
                payment_details: {
                    source: cardData,
                    account_id: process.env.REACT_APP_AUCTIONPAYID,
                    customer: user.card_paymentid,
                    currency: 'usd',
                    description: 'Rush Pass checkout',
                    amount:
                        parseFloat(
                            viewCartItems.reduce((sum, item) => sum + item.qty * item.price, 0),
                        ) * 100,
                },
                site_id: global?.storeDetails?.site_id,
                first_name: user?.first_name,
                last_name: user?.last_name,
                email: user?.email,
            }
            const response = await rushPassFee(paymentBody)
            console.log('rush pass ---', response)
            if (response.status == 'success') {
                console.log('Rush pass Resp ---', response)
                localStorage.setItem('cartData', '')
                setViewCartItems([])
                handleRedirectInternal(history, '')
                setAlert('Rush Pass Purchased SuccessFully!', 'success')
                setPaymentLoading(false)
            } else {
                setPaymentLoading(false)
                setAlert('Something Went Wrong!', 'error')
            }
        }
    }

    useEffect(() => {
        const savedCart = JSON.parse(localStorage.getItem('cartData'))

        if (savedCart.length > 0) {
            const temp = []
            if (savedCart.includes(1)) {
                const singlePass = {
                    id: 1,
                    name: 'Single-Day Pass',
                    price: 5,
                    qty: 1,
                    days: 1,
                }
                temp.push(singlePass)
            }
            if (savedCart.includes(5)) {
                const pass2 = {
                    id: 5,
                    name: '5-Day Pass',
                    price: 20,
                    qty: 1,
                    days: 5,
                }
                temp.push(pass2)
            }

            setViewCartItems(temp)
        }
    }, [])
    console.log('Cart Itemss ---', viewCartItems)
    useEffect(() => {
        if (
            user &&
            global?.pluginConfiguration?.extended_pickup?.enable == 1 &&
            user.card_paymentid
        ) {
            const getData = async () => {
                getAllStripeCards({
                    account_id: process.env.REACT_APP_AUCTIONPAYID,
                    customer_id: user.card_paymentid,
                    object: 'card',
                })
            }
            getData()
        }
    }, [user])

    useEffect(() => {
        if (global?.pluginConfiguration?.extended_pickup?.enable == 1 && get_all_card_details) {
            setAllData(get_all_card_details.records)
        }
    }, [get_all_card_details])

    useEffect(() => {
        setSimilarCart(similar_products)
    }, [similar_products])
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    useEffect(() => {
        if (loader && cardResponseStatus) {
            if (
                cardResponseStatus.from === 'card_source_create' ||
                cardResponseStatus.from === 'card_source_update' ||
                cardResponseStatus.from === 'card_source_delete'
            ) {
                if (cardResponseStatus.status === 'success') {
                    setCardLoading(false)
                    cardClearResponse()
                }
            }
        }
    }, [cardResponseStatus])
    // Handle button click
    // useEffect(() => {
    //     SetCartData(JSON.parse(savedCart))
    //     setCartPass(pValue)
    // }, [window.location.search])

    // useEffect(() => {
    //     if (viewCartItems.length && user && global.pluginConfiguration?.avalara?.enable) {
    //         viewCartItems.map(async (val, index) => {
    //             console.log(val.taxStatus, 'val.taxStatus')
    //             if (val.cart_sales_tax == 0 && val.taxStatus != 'success') {
    //                 // var seller_zipcode = '',
    //                 //     address = ''
    //                 // if (val.custom_field_8) {
    //                 //     seller_zipcode = JSON.parse(val.custom_field_8)?.zipcode
    //                 //         ? JSON.parse(val.custom_field_8).zipcode
    //                 //         : ''
    //                 //     address = JSON.parse(val.custom_field_8)?.address
    //                 //         ? JSON.parse(val.custom_field_8).address
    //                 //         : ''
    //                 // }
    //                 var send_data = {
    //                     site_id: global.storeDetails?.site_id ? global.storeDetails.site_id : '',
    //                     user_id: user?.id,
    //                     price: val.bprice,
    //                     buyer_address: user?.address,
    //                     buyer_city: user?.city,
    //                     buyer_state: user?.state,
    //                     buyer_country: user?.country == '224' ? 'United States' : user?.country,
    //                     buyer_zip: user?.zip,
    //                     seller_address: val.sel_address,
    //                     seller_city: val.sell_city,
    //                     seller_state: val.sell_state,
    //                     seller_country:
    //                         val.sell_country == '224' ? 'United States' : val.sell_country,
    //                     seller_zip: val.sell_zip,
    //                     qty: val.qty,
    //                     cart_id: val.cart_id,
    //                     // site_id: 'AS0513',
    //                     // user_id: '15831',
    //                     // price: '100',
    //                     // buyer_address: '745 Grier Drive Suite 181',
    //                     // buyer_city: 'Richardson',
    //                     // buyer_state: 'Nevada',
    //                     // buyer_country: 'United States',
    //                     // buyer_zip: '89129',
    //                     // seller_address: '745 Grier Drive Suite 181',
    //                     // seller_city: 'Richardson',
    //                     // seller_state: 'Nevada',
    //                     // seller_country: 'United States',
    //                     // seller_zip: '89129',
    //                     // qty: '1',
    //                 }
    //                 const [res_ava] = await Promise.all([
    //                     apiCall(
    //                         'post',
    //                         'getOrderTaxCalculator',
    //                         send_data,
    //                         {},
    //                         'plugin/avalara/service/onBoarding',
    //                     ),
    //                 ])
    //                 console.log('reponse avalara', res_ava)
    //                 if (res_ava?.data?.status === 'success') {
    //                     viewCartItems[index].sales_tax = user.tax_excempt
    //                         ? 0
    //                         : res_ava?.data?.data?.message?.totalTax
    //                         ? res_ava.data.data.message.totalTax
    //                         : 0

    //                     //if (parseInt(index) == 0) {
    //                     var view_cartitems = viewCartItems
    //                     view_cartitems[index].total_payable_amount =
    //                         parseFloat(view_cartitems[index].total_payable_amount) +
    //                         parseFloat(res_ava.data.data.message.totalTax)
    //                     view_cartitems[index].cart_sales_tax = res_ava.data.data.message.totalTax
    //                     view_cartitems[index].taxStatus = 'success'
    //                     setViewCartItems(view_cartitems)
    //                     setSalesTax(_.sumBy(viewCartItems, (x) => parseFloat(x.sales_tax)))
    //                 } else {
    //                     setTotalerror(
    //                         'Calculation error in salestax.please update your correct address details.',
    //                     )
    //                     setAlert(
    //                         'Calculation error in salestax.please update correct address details.',
    //                         'error',
    //                     )
    //                 }
    //             }
    //         })
    //     }
    // }, [viewCartItems, user])

    // useEffect(() => {
    //     if (viewCartItems.length) {
    //         setTotal(
    //             _.sumBy(viewCartItems, (x) => parseFloat(type === 'auction' ? x.amount : x.bprice)),
    //         )
    //         setShippingFee(
    //             _.sumBy(viewCartItems, (x) => parseFloat(x.localpickup == 0 ? x.shipping_fee : 0)),
    //         )
    //         setTransactionFee(_.sumBy(viewCartItems, (x) => parseFloat(x.transaction_fee)))
    //         setSalesTax(_.sumBy(viewCartItems, (x) => parseFloat(x.sales_tax)))
    //         setLineItemFee(
    //             parseFloat(_.sumBy(viewCartItems, (x) => parseFloat(x.qty * x.line_item_fee))),
    //         )
    //         setDeposit(_.sumBy(viewCartItems, (x) => parseFloat(x.deposit_amount)))
    //         setTotalBuyersPremium(
    //             _.sumBy(viewCartItems, (x) => parseFloat(x.buyers_premium + x.charge_fee)),
    //         )
    //         if (global.pluginConfiguration?.shipping?.enable && user) {
    //             viewCartItems.map(async (val, index) => {
    //                 if (
    //                     (parseInt(val.shipping_fee) == 0 || val.shipping_fee == '') &&
    //                     parseInt(val.hasshipping) &&
    //                     ((val.weight != 0 &&
    //                         val.height != 0 &&
    //                         val.length != 0 &&
    //                         val.width != 0) ||
    //                         (val.custom_field_5 != '' &&
    //                             val.custom_field_6 != '' &&
    //                             val.custom_field_7 != '' &&
    //                             val.custom_field_8 != ''))
    //                 ) {
    //                     var seller_zipcode = ''
    //                     if (val.custom_field_8) {
    //                         seller_zipcode = JSON.parse(val.custom_field_8)?.zipcode
    //                             ? JSON.parse(val.custom_field_8).zipcode
    //                             : ''
    //                     }
    //                     var calculation_data = {
    //                         weight: val.weight,
    //                         height: val.height,
    //                         length: val.length,
    //                         width: val.width,
    //                         toPostalCode: user?.zip,
    //                         fromPostalCode: val.seller_zipcode
    //                             ? val.seller_zipcode
    //                             : seller_zipcode,
    //                         site_id: global.storeDetails?.site_id
    //                             ? global.storeDetails.site_id
    //                             : '',
    //                         project_id: val.project_id || 0,
    //                         toCountry: user?.country,
    //                     }
    //                     const [res] = await Promise.all([
    //                         apiCall(
    //                             'post',
    //                             'calculator',
    //                             calculation_data,
    //                             {},
    //                             'plugin/shipstation/service/getRate',
    //                         ),
    //                     ])
    //                     if (res.data?.data) {
    //                         var shipping_rate_calculation = res.data.data
    //                         if (shipping_rate_calculation.message) {
    //                             if (shipping_rate_calculation.message.shipping_status) {
    //                                 if (shipping_rate_calculation.message.shipping_status == 200) {
    //                                     // setShipping_amount(
    //                                     //     shipping_rate_calculation.message.rate[0]?.shipmentCost
    //                                     //         ? parseFloat(shipping_rate_calculation.message.rate[0].shipmentCost)
    //                                     //         : 0,
    //                                     // )
    //                                     ////console.log('pppppppppppppppppppppppp', index_pos)
    //                                     viewCartItems[index].shipping_fee =
    //                                         shipping_rate_calculation.message.rate[0]?.shipmentCost
    //                                             ? parseFloat(
    //                                                   shipping_rate_calculation.message.rate[0]
    //                                                       .shipmentCost,
    //                                               )
    //                                             : 0

    //                                     //if (parseInt(index) == 0) {
    //                                     var view_cartitems = viewCartItems
    //                                     setViewCartItems(view_cartitems)
    //                                     setShippingFee(
    //                                         _.sumBy(view_cartitems, (x) =>
    //                                             parseFloat(x.localpickup == 0 ? x.shipping_fee : 0),
    //                                         ),
    //                                     )
    //                                     //}
    //                                 } else if (
    //                                     shipping_rate_calculation.message.shipping_status == 500
    //                                 ) {
    //                                     setTotalerror(
    //                                         'Product dimensional or Zip Code incorrect.Please check your Zip Code or contact seller.',
    //                                     )
    //                                     setAlert(
    //                                         'Product dimensional or Zip Code incorrect.Please check your Zip Code or contact seller.',
    //                                         'error',
    //                                     )
    //                                 } else {
    //                                     setTotalerror('Please Try Again Later!')
    //                                     setAlert('Please Try Again Later!', 'error')
    //                                 }
    //                             } else {
    //                                 setTotalerror('Please Try Again Later!')
    //                                 setAlert('Please Try Again Later!', 'error')
    //                             }
    //                         }
    //                         setTimeout(() => {
    //                             clearAlert()
    //                         }, 5000)
    //                     }
    //                 }
    //             })
    //         }
    //     }
    // }, [viewCartItems, user])

    const handleDelete = async (id) => {
        setViewCartItems((prev) => {
            const exists = prev.some((item) => item.id === id)

            const updated = exists ? prev.filter((item) => item.id !== id) : [...prev, { id }]
            localStorage.setItem('cartData', JSON.stringify(updated.map((i) => i.id)))

            return updated
        })
    }

    useEffect(() => {
        if (remove_id > 0) {
            handleDelete(remove_id)
        }
    }, [remove_id])

    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'

    return (
        <>
            <UserActivity page="user_cart" />
            <div className={`${isVarifiedGfTheme ? 'customContainer pt-2' : 'container pt-5'}`}>
                <>
                    {viewCartItems.length !== 0 ? (
                        <div className="row justify-content-center">
                            <div className="col-md-12">
                                <div className="cart-table">
                                    <div className="table-responsive">
                                        <table id="myTable" className="table">
                                            <thead>
                                                <tr>
                                                    <th>{t('Name')}</th>
                                                    <th>{t('Per Price')}</th>
                                                    <th>{t('Qty')}</th>
                                                    {/* <th>{t('Total Days')}</th> */}
                                                    <th>{t('Amount')}</th>
                                                    <th className="text-center">{t('Action')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {viewCartItems.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{item.name}</td>
                                                            <td>
                                                                {currencyFormat(
                                                                    parseFloat(item.price),
                                                                )}
                                                            </td>
                                                            <td data-title="Qty">
                                                                <div className="qty-input">
                                                                    <span
                                                                        id="qty"
                                                                        className="amount"
                                                                        style={{
                                                                            width: '150px',
                                                                            display: 'block',
                                                                        }}
                                                                    >
                                                                        <CustomInput
                                                                            key={item.id}
                                                                            value={item.qty}
                                                                            onChange={(e) => {
                                                                                const newQty =
                                                                                    Number(
                                                                                        e.target
                                                                                            .value,
                                                                                    )

                                                                                if (
                                                                                    !newQty ||
                                                                                    newQty < 1
                                                                                )
                                                                                    return

                                                                                setViewCartItems(
                                                                                    (prev) =>
                                                                                        prev.map(
                                                                                            (
                                                                                                prevItem,
                                                                                            ) =>
                                                                                                prevItem.id ===
                                                                                                item.id
                                                                                                    ? {
                                                                                                          ...prevItem,
                                                                                                          qty: newQty,
                                                                                                      }
                                                                                                    : prevItem,
                                                                                        ),
                                                                                )
                                                                            }}
                                                                            name="qty"
                                                                            placeholder="Enter Qty"
                                                                            type="number"
                                                                            min={1}
                                                                        />
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            {/* <td>{item.qty * item.days}</td> */}
                                                            <td className="text-left">
                                                                {currencyFormat(
                                                                    parseFloat(
                                                                        item.qty * item.price,
                                                                    ),
                                                                )}
                                                            </td>
                                                            <td className="ct-action">
                                                                {' '}
                                                                <a
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                    }}
                                                                    onClick={() =>
                                                                        handleDelete(item.id)
                                                                    }
                                                                >
                                                                    {' '}
                                                                    <span className="material-icons">
                                                                        delete
                                                                    </span>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="cartAmtPay">
                                        <div className="caVal d-flex justify-content-between align-items-center">
                                            <p>{t('to_tal')} : </p>
                                            <span id="total" className="total">
                                                {/* {currencyFormat(item.qty * item.price)} */}
                                                {currencyFormat(
                                                    parseFloat(
                                                        viewCartItems.reduce(
                                                            (sum, item) =>
                                                                sum + item.qty * item.price,
                                                            0,
                                                        ),
                                                    ),
                                                )}
                                            </span>
                                        </div>
                                        <div className="cardSecton">
                                            {allData &&
                                                allData.map((data, index) => (
                                                    <div key={index} className="cardSelect 1233">
                                                        <label
                                                            htmlFor={`ritemb${index}`}
                                                            className="cardmain"
                                                        >
                                                            <div className="flx">
                                                                <p>
                                                                    {global.storeConfigration
                                                                        ?.enable_cardknox?.value ===
                                                                    '1'
                                                                        ? data.MaskedNumber
                                                                        : 'xxxx-xxxx-xxxx-' +
                                                                          data.last4}
                                                                </p>
                                                                <div className="radio-item">
                                                                    <label className="custom-checkbox">
                                                                        <input
                                                                            type="checkbox"
                                                                            id={`ritemb${index}`}
                                                                            name="ritem"
                                                                            value={data.id}
                                                                            checked={
                                                                                cardData === data.id
                                                                            }
                                                                            onChange={onChangeCard}
                                                                        />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                    {/* <span className="vcRad"></span> */}
                                                                </div>
                                                            </div>
                                                            <div className="flx">
                                                                <p>{data.brand}</p>
                                                                <p>
                                                                    {data.exp_month}/{data.exp_year}
                                                                </p>
                                                            </div>
                                                        </label>
                                                    </div>
                                                ))}
                                        </div>
                                        <div
                                            className="text-center cartActBtn"
                                            style={{ marginBottom: '45px' }}
                                        >
                                            <div className="rushPassBtnBox">
                                                <PrimaryButton
                                                    label={
                                                        paymentLoading
                                                            ? 'Please wait...'
                                                            : 'Make Payment'
                                                    }
                                                    className="w-auto"
                                                    onClick={() => {
                                                        handleRushPassPayment()
                                                    }}
                                                    disabled={paymentLoading}
                                                />
                                                {/* <div className="billingContainer btnROot">
                                                    <Link
                                                        to="/dashboard/cards"
                                                        className="addnewCard"
                                                    >
                                                        Add New Card
                                                    </Link>
                                                </div> */}
                                                <PrimaryButton
                                                    onClick={() =>
                                                        handleRedirectInternal(
                                                            history,
                                                            'dashboard/cards',
                                                        )
                                                    }
                                                    label="Add New Card"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : isVarifiedGfTheme ? (
                        <NoRecordsFound />
                    ) : (
                        <Nodata />
                    )}
                </>
            </div>
        </>
    )
}

export default RushCart
